const useListColumns = () => {
  return [
    {
      Header: "Year",
      accessor: "year",
      disableGlobalFilter: true,
    },
    {
      Header: "Category",
      accessor: "category",
      disableGlobalFilter: true,
    },
    {
      Header: "Artist",
      accessor: "artist.displayName",
      disableGlobalFilter: true,
    },
    {
      Header: "Created At",
      accessor: "createDate",
      disableGlobalFilter: true,
      sortType: (rowA: any, rowB: any) => rowA.original._createDateTs - rowB.original._createDateTs,
    },
    {
      Header: "",
      accessor: "actions",
      disableSortBy: true,
      disableGlobalFilter: true,
    },
  ];
};

export default useListColumns;
